<template>
<AuthShell>

    <v-snackbar
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      v-model="snackbar.show"
    >
      {{ snackbar.message }}
    </v-snackbar>

    <v-form ref="form" @submit.prevent="logmasuk">
      <div class="auth-kening">Log Masuk</div>
      <h2 class="auth-tajuk">Masuk ke akaun anda</h2>
      <p class="auth-nota">Gunakan emel dan kata laluan yang didaftarkan.</p>

      <v-text-field
        type="email"
        name="email"
        autocomplete="username"
        label="Emel"
        outlined
        color="#037769"
        prepend-inner-icon="mdi-email-outline"
        v-model="logmasukemel"
        :rules="[required('emel'), rules.email]"
      ></v-text-field>

      <v-text-field
        name="password"
        autocomplete="current-password"
        label="Kata Laluan"
        outlined
        color="#037769"
        prepend-inner-icon="mdi-lock-outline"
        :type="paparkatalaluan ? 'text' : 'password'"
        :append-icon="paparkatalaluan ? 'mdi-eye' : 'mdi-eye-off'"
        @click:append="paparkatalaluan = !paparkatalaluan"
        v-model="logmasukkatalaluan"
        :rules="logmasukkatalaluanRules"
      ></v-text-field>

      <!-- Berdiri di sebelah medan yang gagal, bukan di bar atas: pengguna
           mencari pautan ini pada saat kata laluan tidak menjadi, dan ketika
           itu mata mereka berada di sini. -->
      <div class="auth-pautan">
        <a href="#" @click.prevent="kelupakatalaluan">{{$t('lupakatalaluan')}}</a>
      </div>

      <button class="auth-butang" type="submit">
        <span>Log Masuk</span>
        <v-icon class="auth-butang__anak" size="20">mdi-arrow-right</v-icon>
      </button>
    </v-form>

    <!-- Langkah KEDUA log masuk, bukan dialog tetapan: kata laluan sudah betul,
         akaun ini cuma memegang lebih daripada satu peranan. Jalur kepala teal
         yang sama seperti panel jenama menjadikannya sambungan aliran itu, dan
         bukan gangguan di tengah jalan. -->
    <v-dialog
      v-model="dialogpaparperanan"
      persistent
      max-width="440px"
      content-class="peranan"
    >
      <v-card class="peranan__kad">
        <v-form ref="formloginpilihanperanan" @submit.prevent="logmasukperananpilihan">

          <div class="peranan__kepala">
            <span class="peranan__jubin"><v-icon size="20">mdi-account-switch-outline</v-icon></span>
            <div>
              <div class="peranan__kening">Langkah 2 daripada 2</div>
              <div class="peranan__tajuk">{{$t('pilih')}} {{$t('peranan')}}</div>
            </div>
          </div>

          <div class="peranan__isi">
            <p class="peranan__nota">
              Akaun ini memegang lebih daripada satu peranan. Pilih peranan untuk sesi ini —
              ia menentukan menu dan data yang anda boleh capai.
            </p>

            <v-select
              outlined
              color="#037769"
              item-color="#037769"
              menu-props="offset-y"
              prepend-inner-icon="mdi-account-outline"
              :items="pilihperanan"
              v-model="logmasukperananpilihanperanan"
              v-bind:label="$t('peranan')"
              :rules="[required('peranan')]"
              item-text="nama"
              item-value="id"
            ></v-select>

            <div class="peranan__aksi">
              <button type="button" class="auth-batal" @click="dialogpaparperanan = false">
                {{$t('tutup')}}
              </button>
              <button type="submit" class="auth-butang auth-butang--padat">
                <span>{{$t('hantar')}}</span>
                <v-icon class="auth-butang__anak" size="18">mdi-arrow-right</v-icon>
              </button>
            </div>
          </div>

        </v-form>
      </v-card>
    </v-dialog>

    <!-- <v-alert
      v-show="toggle"
      color="pink"
      dark
      border="top"
      icon="mdi-circle"
      transition="scale-transition"
    >
     Pengisian bagi HID ini telah selesai!
    </v-alert> -->

</AuthShell>
</template>
<script>
import axios from 'axios'
import i18n from '@/i18n'
import AuthShell from '@/components/AuthShell/AuthShell'
import getLocalStorage from '@/services/getLocalStorage'
const localStorageData = new getLocalStorage();

//////////////services//////////////////
import pubServices from '@/services/publicServices'
const publicServices = new pubServices();

export default {
    name: 'Logmasuk',
    components: {
        AuthShell
    },
    data() {
        return {
            snackbar: "",
            loading: false,
            poForm: true,
            isDisabled: true,
            respondenForm: false,
            dialogpaparperanan: false,
            paparkatalaluan: false,
            pilihperanan: [],
            publicHIDdata:'',
            HID:'',
            TAC:"",
            toggle: false,
            logmasukemel: '',
            logmasuknama: '',
            logmasukkatalaluan: '',
            logmasukperananpilihanemel: '',
            logmasukperananpilihankatalaluan: '',
            logmasukperananpilihanperanan: '',
            required(text){
                return (v) =>
                (v && v.length > 0) || `${i18n.t(text)} ${i18n.t('adalah diperlukan')}`
            },
            rules: {
                email: value => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    return pattern.test(value) || `${i18n.t('emeltidaklengkap')}`;
                },
            },
            logmasuknamaRules: [
                v => !!v || 'Name is required',
                v => (v && v.length >= 6) || 'Name must be more than 6 characters',
            ],
            logmasukkatalaluanRules: [
                v => !!v || `${i18n.t('Password adalah diperlukan')}`
            ],
            res: null,
            defaultError: null
        }
    },
    props: {
        source: String
    },
    methods:{
        kelupakatalaluan(){
            this.$router.push(`/${i18n.locale}/lupatakalaluan`).catch(err => {
                if (err.name !== 'NavigationDuplicated') {
                    throw err;
                }
            });
        },
        async logmasuk(){
            if(this.$refs.form.validate()){
                setTimeout(() => {

                }, 2000);
                await axios.post(`${process.env.VUE_APP_API_URL}/auth/logmasuk`, {
                    logmasukemel: this.logmasukemel,
                    logmasukkatalaluan: this.logmasukkatalaluan
                })
                .then(response => {
                    //console.log(response.data.status)
                    if(!response.data.status){
                        if(response.data.message === 'Pilih peranan'){
                            this.dialogpaparperanan = true
                            this.pilihperanan = response.data.pilihperanan
                            this.logmasukperananpilihanperanan = ''
                        } else {
                            this.snackbar = {
                                message: `${response.data.message}`,
                                timeout: 2000,
                                color: "red darken-4",
                                show: true,
                            };
                        }
                    } else {
                        window.localStorage.setItem('tokenexport', response.data.data.tokenexport)
                        window.localStorage.setItem('access_token', response.data.data.token)
                        window.localStorage.setItem('user', JSON.stringify(response.data.data.user))
                        this.loading = false
                        this.$router.push(`/${i18n.locale}/paparanutama`)
                    }
                })
                .catch(error => {
                    console.log(error)
                    //console.log(error)
                })
            }
        },
        async logmasukHID(){
            try{
                var res = await publicServices.getBorangByHID(this.HID);//dapatkan data HID
                await axios.post(`${process.env.VUE_APP_API_URL}/public/logmasukresponden?`, {
                    HID:this.HID,
                    HIESID:this.TAC
                }).then(result=>{
                    if(result.data.status){
                        this.publicHIDdata = res.data.data;
                        var statusHID = res.data.data.statusHID;

                        if(statusHID == 1){
                            localStorageData.setHID(this.publicHIDdata)
                            window.localStorage.setItem('access_token', result.data.data.token)
                            window.localStorage.setItem('user', JSON.stringify(result.data.data.user))
                            this.loading = false
                            this.$router.push(`/${i18n.locale}/ringkasanMaklumatIR`)
                        }else{
                            this.toggle = true;
                            setTimeout(() => (this.toggle = false), 2000);
                        }

                    } else {
                        this.snackbar = {
                            message: i18n.t("berjaya"),
                            timeout: 2000,
                            color: "success",
                            show: true,
                        };
                    }

                })

            }catch(err){
                console.log(err)
            }

        },
        async logmasukperananpilihan(){
            // `formloginpilihanperanan` DAN `form`: kaedah ini menghantar semula
            // emel/kata laluan bersama peranan, tetapi hanya borang log masuk
            // yang disemak sebelum ini — jadi menekan Hantar tanpa memilih
            // peranan menghantar peranan kosong ke backend dan gagal secara
            // senyap, sedangkan peraturan pada <v-select> tidak pernah dipapar.
            if(this.$refs.formloginpilihanperanan.validate() && this.$refs.form.validate()){
                this.logmasukperananpilihanemel = this.logmasukemel
                this.logmasukperananpilihankatalaluan = this.logmasukkatalaluan
                await axios.post(`${process.env.VUE_APP_API_URL}/auth/logmasukpelbagaiperanan`, {
                    logmasukperananpilihanemel: this.logmasukperananpilihanemel,
                    logmasukperananpilihankatalaluan: this.logmasukperananpilihankatalaluan,
                    logmasukperananpilihanperanan: this.logmasukperananpilihanperanan
                })
                .then(response => {
                    if(!response.data.status){
                        this.snackbar = {
                            message: `${response.data.message}`,
                            timeout: 2000,
                            color: "red darken-4",
                            show: true,
                        };
                    } else {
                        window.localStorage.setItem('tokenexport', response.data.data.tokenexport)
                        window.localStorage.setItem('access_token', response.data.data.token)
                        window.localStorage.setItem('user', JSON.stringify(response.data.data.user))
                        this.loading = false
                        this.$router.push(`/${i18n.locale}/paparanutama`)
                    }
                })
                .catch(error => {
                    console.log(error)
                    //alert(error)
                })
            }
        }

    },
    watch:{
        HID(val){
            if(val.length >0){
                this.isDisabled = false;
            }else{
                this.isDisabled =  true;
            }
        }
    }
}
</script>

<style scoped>
/* ======================= DIALOG PILIH PERANAN =======================
   Semua nilai di sini HEX literal, BUKAN var(--auth-*): Vuetify memindahkan
   kandungan v-dialog ke akar aplikasi, di luar `.auth`, tempat pembolehubah
   itu diisytiharkan. Di sana ia tidak terurai dan warna runtuh. */
.peranan__kad {
  border-radius: 4px;
}
.peranan__kepala {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 18px 24px;
  background: linear-gradient(120deg, #01463e 0%, #026254 46%, #048374 100%);
}
.peranan__jubin {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  border-radius: 50%;
  background: rgba(127, 233, 221, .18);
  border: 1px solid rgba(127, 233, 221, .45);
}
.peranan__jubin .v-icon {
  color: #7fe9dd !important;
}
/* Kening menamakan KEDUDUKAN dalam aliran, bukan menghias: pengguna tiba di
   sini secara tidak dijangka selepas menekan Log Masuk, jadi "Langkah 2
   daripada 2" menjawab soalan pertama mereka — berapa lama lagi. */
.peranan__kening {
  font-size: var(--fs-3xs);
  font-weight: 600;
  letter-spacing: 1.2px;
  text-transform: uppercase;
  color: #7fe9dd;
}
.peranan__tajuk {
  font-size: var(--fs-lg);
  font-weight: 700;
  color: #ffffff;
  line-height: 1.3;
}
.peranan__isi {
  padding: 22px 24px 20px;
}
/* Aksen medan diulang di sini dan bukan diwarisi daripada helaian `.auth`:
   dialog ini hidup di akar aplikasi, di luar `.auth`. */
.peranan__isi ::v-deep .v-input__prepend-inner .v-icon {
  color: #048374;
}
.peranan__isi ::v-deep .v-text-field--outlined fieldset {
  border-color: #dbeeeb;
}
.peranan__isi ::v-deep .v-text-field--outlined:hover fieldset {
  border-color: #9fd3cb;
}
.peranan__nota {
  font-size: var(--fs-sm);
  line-height: 1.55;
  color: #5d7a76;
  margin: 0 0 18px;
}
.peranan__aksi {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
}
</style>
